// extracted by mini-css-extract-plugin
export default {"carts":"cart_carts__98nZr","main":"cart_main__CFnW3"};